/*------------------------------------------------------------------
Import styles
------------------------------------------------------------------*/

import '../styles/style.scss';

/* ----------------------------------------------
Import and assign modules as global variables
---------------------------------------------- */

import * as Meteora from 'meteora';
import Classy from '@meteora-digital/classy';
import TweenController from '@meteora-digital/tween';
import ModalController from '@meteora-digital/modal';
import VideoController from 'scripts/classes/video-embed';
import { tns } from 'tiny-slider/src/tiny-slider';
import Watcher from './classes/watcher';
window.Classy = Classy;
window.Meteora = Meteora;
window.TweenController = TweenController;
window.VideoController = VideoController;
window.ModalController = ModalController;
window.Watcher = Watcher;
window.TNS = tns;

/*------------------------------------------------------------------
Add conditional scripts to the ScriptLoader object below
------------------------------------------------------------------*/

document.addEventListener('DOMContentLoaded', function () {
  // Add the src and a condition required to load the script
  window.CriticalLoader = ScriptLoader({
    './components/global': true,
    './elements/header': document.querySelector('.js-header'),
    './elements/mobile-menu': document.querySelector('.js-mobile-menu'),
    './components/breakpoints': document.querySelector('[data-breakpoint]'),
    './components/parallax': document.querySelector('[data-parallax]'),
    './components/equalizer': document.querySelector('[data-equalize-watch]'),
    './elements/banner': document.querySelector('.js-banner'),
    './elements/fixed-banner': document.querySelector('.js-banner'),
    './elements/svg-text': document.querySelector('.js-svg-text')
  }, 'critical-loaded');
});
window.addEventListener('critical-loaded', function () {
  console.log("%cmarmalade", "color:#0c0c0d; font-family: monospace; font-size: 20px; padding: 5px 10px; border-radius: 5px; background-color: #bbb");
  document.body.classList.add('scripts-loaded', 'page-visible');
  window.ScrollLocker.unlock();

  // Only once the critical scripts have loaded, load the rest of the scripts
  // Add the src and a condition required to load the script
  window.ScriptLoader = ScriptLoader({
    './elements/videos': document.querySelector('[data-video]'),
    './elements/video-modals': document.querySelector('[data-video-modal]'),
    './elements/forms': document.querySelector('form.userform, .js-form form'),
    './blocks/default/map': document.querySelector('.js-map'),
    './blocks/default/slider': document.querySelector('.js-default-slider'),
    './blocks/default/blog': document.querySelector('.js-default-blog'),
    './blocks/default/services': document.querySelector('.js-default-services'),
    './blocks/default/team': document.querySelector('.js-default-team'),
    './blocks/tiled/slider': document.querySelector('.js-tiled-slider'),
    './blocks/accordion': document.querySelector('.js-accordion'),
    './blocks/tabs': document.querySelector('.js-tabs'),
    './blocks/default/tabbed-accordion': document.querySelector('.js-default-tabbed-accordion'),
    './blocks/default/tabbed-slider': document.querySelector('.js-default-tabbed-slider'),
    './blocks/default/fold': document.querySelector('.js-blocks-fold'),
    './blocks/default/logo': document.querySelector('.js-default-logo'),
    './blocks/jukebox/link': document.querySelector('.js-jukebox-link'),
    './blocks/offices/map': document.querySelector('.js-offices-map'),
    './pages/projects': document.querySelector('.js-projects'),
    './pages/filter-pages': document.querySelector('.js-filter')
  });
});

/*------------------------------------------------------------------
Script Loader
------------------------------------------------------------------*/

function ScriptLoader() {
  var imports = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var evt = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'scripts-loaded';
  // An array of the import object keys
  var scripts = Object.keys(imports);
  // For debugging purposes only
  var components = [];
  var load = function load() {
    var i = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : -1;
    // Make sure we have a script to import
    if (i >= scripts.length) {
      // Once everything has loaded, fire a 'scripts-loaded' event
      setTimeout(function () {
        return window.dispatchEvent(new Event(evt));
      }, 500);
      return;
    }
    ;

    // Increment the index
    i += 1;

    // If this script is not needed, continue to the next script;
    if (!imports[scripts[i]]) {
      load(i);
      return;
    }
    ;

    // Otherwise continue on to load the script
    import("".concat(scripts[i])).then(function () {
      return components.push(scripts[i]);
    })["catch"](function (error) {
      return console.warn(scripts[i], error);
    })["finally"](function () {
      return load(i);
    });
  };
  load();
  return components;
}

// window.addEventListener('critical-loaded', () => {

// });